const getDisplay = () => ({
  $block
}) => $block ? "block" : "inline-block";
export default getDisplay;